import {css} from 'styled-components';
import { devices } from '@/styles/theme/index.jsx';


export const globalStyleGap = css`
        .p-0 {
                padding: 0 !important;
        }

        .pl-0 {
                padding-left: 0;
        }

        .pr-0 {
                padding-right: 0;
        }

        .pt-200 {
                padding-top: 200px;

                ${devices.sm} {
                        padding-top: 100px;
                }
        }

        .pb-200 {
                padding-bottom: 200px;

                ${devices.sm} {
                        padding-bottom: 100px;
                }
        }

        .pt-160 {
                padding-top: 160px;

                ${devices.sm} {
                        padding-top: 100px;
                }
        }

        .pb-160 {
                padding-bottom: 160px;

                ${devices.sm} {
                        padding-bottom: 100px;
                }
        }

        .pt-150 {
                padding-top: 150px;

                ${devices.sm} {
                        padding-top: 100px;
                }
        }

        .pb-150 {
                padding-bottom: 150px;

                ${devices.sm} {
                        padding-bottom: 100px;
                }
        }

        .pb-130 {
                padding-bottom: 130px;

                ${devices.sm} {
                        padding-bottom: 100px;
                }
        }

        .pt-100 {
                padding-top: 100px;

                ${devices.sm} {
                        padding-top: 60px;
                }
        }

        .pb-100 {
                padding-bottom: 100px;

                ${devices.sm} {
                        padding-bottom: 60px;
                }
        }

        .pt-80 {
                padding-top: 80px;

                ${devices.sm} {
                        padding-top: 40px;
                }
        }

        .pb-80 {
                padding-bottom: 80px;

                ${devices.sm} {
                        padding-bottom: 40px;
                }
        }

        .mt-20 {
                margin-top: 20px;
        }

        .mt-40 {
                margin-top: 40px;
        }

        .mt-60 {
                margin-top: 60px;
        }

        .mb80 {
                margin-bottom: 80px;

                ${devices.sm} {
                        margin-bottom: 40px;
                }
        }

        .pt200 {
                padding-top: 200px !important;

                ${devices.sm} {
                        padding-top: 120px !important;
                }
        }

        .pb200 {
                padding-bottom: 200px !important;
                ${devices.sm}) {
                padding-bottom: 120px !important;
        }
        }

`;

